import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/approval-work-flows', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/approval-work-flows/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/approval-work-flows/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApprovalType = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows/approval-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getParameters = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows/get-params', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApproverType = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows/approver-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApprovalActivity = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows/approval-activities', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getConditionType = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows/condition-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApprovalOperator = (Options = {}) => {
  return httpClient
    .get('/api/approval-work-flows/approval-operators', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const storeCondition = data => {
  return httpClient
    .post('/api/approval-work-flows-conditions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroyCondition = id => {
  return httpClient
    .delete(`/api/approval-work-flows-conditions/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  update,
  destroy,
  getApprovalType,
  getParameters,
  getApproverType,
  getApprovalActivity,
  getConditionType,
  getApprovalOperator,
  storeCondition,
  destroyCondition
}
